import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ParamsProvider, useParams2 } from "./contexts/ParamsContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import PageTracker from "./components/PageTracker";
import Accueil from "./pages/Accueil";
import Actualites from "./pages/Actualites";
import ActualiteDetail from "./pages/ActualiteDetail";
import Commune from "./pages/Commune";
import Demarches from "./pages/Demarches";
import VieLocale from "./pages/VieLocale";
import CircuitsRandonnee from "./pages/CircuitsRandonnee";
import ConseilMunicipal from "./pages/ConseilMunicipal";
import Rubrique from "./pages/Rubrique";
import ReserverSalle from "./pages/ReserverSalle";
import ContratSalle from "./pages/ContratSalle";
import EtatDesLieux from "./pages/EtatDesLieux";
import MentionsLegales from "./pages/MentionsLegales";
import Calendrier from "./pages/Calendrier";
import Signalements from "./pages/Signalements";
import Inscription from "./pages/Inscription";
import Connexion from "./pages/Connexion";
import MotDePasseOublie from "./pages/MotDePasseOublie";
import ReinitialiserMotDePasse from "./pages/ReinitialiserMotDePasse";
import Cartographie from "./pages/Cartographie";
import Bibliotheque from "./pages/Bibliotheque";
import BibliothequeLivreDetail from "./pages/BibliothequeLivreDetail";
import EspaceLibraire from "./pages/EspaceLibraire";
import BarAssociatif from "./pages/BarAssociatif";
import EspaceBarman from "./pages/EspaceBarman";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="container">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  return children;
}

function PublicSite() {
  const params = useParams2();
  return (
    <>
      <Nav />
      <PageTracker />
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/actualites/:slug" element={<ActualiteDetail />} />
        <Route path="/commune" element={<Commune />} />
        <Route path="/demarches" element={<Demarches />} />
        <Route path="/vie-locale" element={<VieLocale />} />
        <Route path="/circuits-randonnee" element={<CircuitsRandonnee />} />
        <Route path="/conseil-municipal" element={<ConseilMunicipal />} />
        <Route path="/rubrique/:cle" element={<Rubrique />} />
        <Route path="/reserver-salle" element={<ReserverSalle />} />
        <Route path="/contrat-salle/:id" element={<ContratSalle />} />
        <Route path="/etat-des-lieux/:id" element={<EtatDesLieux />} />
        <Route path="/calendrier" element={<Calendrier />} />
        <Route path="/signalements" element={<Signalements />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
        <Route path="/reinitialiser-mot-de-passe" element={<ReinitialiserMotDePasse />} />
        <Route path="/cartographie" element={<Cartographie />} />
        <Route path="/bibliotheque" element={<Bibliotheque />} />
        <Route path="/bibliotheque/livre/:id" element={<BibliothequeLivreDetail />} />
        <Route path="/espace-libraire" element={<EspaceLibraire />} />
        <Route path="/bar-associatif" element={<BarAssociatif />} />
        <Route path="/espace-barman" element={<EspaceBarman />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedAdmin><Admin /></ProtectedAdmin>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer params={params} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ParamsProvider>
        <PublicSite />
      </ParamsProvider>
    </AuthProvider>
  );
}
